import { render, staticRenderFns } from "./MIntroduce.vue?vue&type=template&id=4f713310&scoped=true"
import script from "./MIntroduce.vue?vue&type=script&lang=js"
export * from "./MIntroduce.vue?vue&type=script&lang=js"
import style0 from "./MIntroduce.vue?vue&type=style&index=0&id=4f713310&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f713310",
  null
  
)

export default component.exports